import React, { useEffect, useState } from "react";

import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Grid2,
  Stack,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import { BsFillPersonBadgeFill, BsFillTelephoneFill } from "react-icons/bs";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import BASEURL from "../../Utils/Baseurl";

import {allCustomer, allprospect, getContactdetails, getOrganisationname, getUserHierarchy } from "../callQuery.js";
import request from "graphql-request";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider.jsx";
import { fromGlobalId } from "../../../lib/decoded/rawPk.js";

import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog/index.js";
import { WhatsApp } from "@mui/icons-material";
import { CreateWhatsAppLog, DeleteWhatsAppLog, getAllTask, GetWhatsAppLogById, UpdateWhatsappLog } from "./GraphQl/index.js";
import { useLoading } from "../../../context/LodingContext.jsx";
import { useSuccess } from "../../../context/SucccessContext.jsx";
import { useError } from "../../../context/ErrorContext.jsx";

const AddWhatsappLog = () => {
  const useroptions = [
    {
      value: "customer",
      label: "Customer",
    },
    {
      value: "lead and prospect",
      label: "Prospect",
    },
  ];

  const calltype = [
    {
      value: "Successful",
      label: "Successful",
    },
    {
      value: "Follow-Up Needed",
      label: "Follow-Up Needed",
    },

    {
      value: " No Response",
      label: " No Response",
    },
  ];

  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);

  
  const params = useLocation();
  const id = params.search.slice(1);
  const decodedId = atob(currentUser?.id);
  const userID = decodedId.split(":")[1];
  
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const [dropOption, setdropOption] = useState([]);
  const [userData, setuserData] = useState([]);
  
  const [userName, setuserName] = useState([]);
  const [ TaskId, setTaskId ] = useState();
  
  const [Data, setData] = useState({});
  const [isOtherUserType, setIsOtherUserType] = useState(false);
  const [ titleOptions, setTitleOptions ] = useState();
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();  
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [callData, setcallData] = useState({
    taskTitle: "",
    taskTitleStatus: "unchecked",
    callType: "",
    callTypeStatus: "unchecked",
  });

  const [callfieldData, setcallfieldData] = useState({
    callType: "",
    callTypeStatus: "unchecked",
    startDate: today,
    startDateStatus: "unchecked",
    startTime: "",
    startTimeStatus: "unchecked",
    endTime: "",
    endTimeStatus: "unchecked",
    duration: "",
    durationStatus: "unchecked",
    description: "",
    descriptionStatus: "unchecked",
  });
  


  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await request(BASEURL, getUserHierarchy, {
          id: rawPk,
        });
        setdropOption(response?.getUserHierarchy);
      } catch (err) {
        console.error("Error", err);
      }
    };
    fetchdata();
  }, []);

  useEffect(() => {
    let prevState = { ...callfieldData };

    prevState.startDateStatus = "success";
    setcallfieldData(prevState);
  }, []);

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  useEffect(() => {
    fetchAllTask();
  },[]);

  useEffect(() => {
    if (id) {
        fetchWhatsappDataById();
    }
  }, [id]);

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      callfieldData.startDateStatus === "success" &&
      callfieldData.startTimeStatus === "success" &&
      callfieldData.durationStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

    //Fetch Task Title
    const fetchAllTask = async() => {
      try{
        const response = await request(BASEURL, getAllTask);
        const data = response?.allTasks?.data;
        const options = data?.map((task) => ({
          label: task.title,
          value: task.id,
        }));
        setTitleOptions(options);
        
      }
      catch(error){
        console.error("Error Fetching Data", error);
      }
    }


  //Fetch By ID
  const fetchWhatsappDataById = async() => {
    try{
      const response =  await request(BASEURL, GetWhatsAppLogById, {
        id: id,
      });
      const responseData = response?.getWhatsappLogById.data?.[0];
      if(responseData){
        setcallData({
          preparedBy: { label: responseData.assignedTo.username, value: responseData.assignedTo.id },
          taskTitle: { label: responseData?.task?.title, value: responseData?.task?.id},
          organizationName: { 
            label: responseData.customer != null ? responseData.customer.legalName : responseData.lead.companyName,
            value: responseData.customer !=null ? responseData.customer.id : responseData.lead.id,
           },
          userType: { 
            label: responseData.customer != null ? "Customer": "Prospect",
            value: responseData.customer != null ? "customer": "lead and prospect"
          },

          preparedByStatus: { label: responseData.assignedTo.username, value: responseData.assignedTo.id } ? "success" : "unchecked",
          taskTitleStatus: { label: responseData?.task?.title, value: responseData?.task?.id} ? "success" : "unchecked",
          organizationNameStatus: { 
            label: responseData.customer != null ? responseData.customer.legalName : responseData.lead.companyName,
            value: responseData.customer !=null ? responseData.customer.id : responseData.lead.id,
           } ? "success" : "unchecked",
          userTypeStatus: { 
            label: responseData.customer != null ? "Customer": "Prospect",
            value: responseData.customer != null ? "customer": "lead and prospect"
          } ? "success" : "unchecked",

        });
        setcallfieldData({
          callType: {value: responseData.outcome, label: responseData.outcome},
          // organization : {            
          //   label: responseData.customer != null ? responseData.customer.legalName : responseData.lead.companyName,
          //   value: responseData.customer !=null ? responseData.customer.id : responseData.lead.id,
          // },
          description: responseData.followUpActions,
          duration: responseData.duration,
          endTime: responseData.chatendTime,
          startTime: responseData.chatstartTime,
          startDate: responseData.chatDate,

          callTypeStatus: {value: responseData.outcome, label: responseData.outcome} ? "success" : "unchecked",
          descriptionStatus: responseData.followUpActions ? "success" : "unchecked",
          durationStatus: responseData.duration ? "success" : "unchecked",
          endTimeStatus: responseData.chatendTime ? "success" : "unchecked",
          startTimeStatus: responseData.chatstartTime ? "success" : "unchecked",
          startDateStatus: responseData.chatDate ? "success" : "unchecked",
        });
      }
    }
    catch(error){
      console.error("Error fetching Data", error);
    }
  }
  
  //Create Mutation
  const handleAddWhatsappLogData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true)
        const values = {
          userId: parseInt(callData.preparedBy?.value), //Associated By
          masterId: parseInt(userID),
          taskId: parseInt(TaskId),
          customerId:  parseInt(callData.userType.value == "customer"
          ? callData.organizationName?.value
          : ""),
          leadId: parseInt(callData.userType.value == "lead and prospect"
          ? callData.organizationName?.value
          : ""),
          chatDate: callfieldData.startDate,
          chatstartTime: callfieldData.startTime,
          chatendTime : callfieldData.endTime,
          duration: callfieldData.duration,
          outcome: callfieldData.callType?.value,
          followUpActions: callfieldData.description,
        };
        
        try{
          const response = await request(BASEURL, CreateWhatsAppLog, {
            input: values
          });
          
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setSuccessStatus(true);
          setSucessTitle("Whatsapp log Created");
          setTimeout(()=> {
            setSuccessStatus(false);
            navigate("/whatsapplog")
          },1000);
        }
        catch(error){
          console.error("Error Submitting Data", error);
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setErrorStatus(true);
          setErrormessage("Error Submitting Whatsapp log");

          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
        finally{
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  // Edit Mutation
  const handleEditWhatsappLogData = async() => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to update your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: async () => {
          const value = {
            id: id,
            userId: parseInt(callData.preparedBy?.value), //Associated By
            masterId: parseInt(userID),
            taskId: parseInt(callData.taskTitle?.value),
            customerId:  parseInt(callData.userType.value == "customer"
            ? callData.organizationName?.value
            : ""),
            leadId: parseInt(callData.userType.value == "lead and prospect"
            ? callData.organizationName?.value
            : ""),
            chatDate: callfieldData.startDate,
            chatstartTime: callfieldData.startTime,
            chatendTime : callfieldData.endTime,
            duration: callfieldData.duration,
            outcome: callfieldData.callType?.value,
            followUpActions: callfieldData.description,
          }
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);
          try{
            const response = await request(BASEURL, UpdateWhatsappLog, {
              input: value
            });
            setSuccessStatus(true);
            setSucessTitle("Whatsapp Log Updated ");
            setTimeout(() => {
                setSuccessStatus(false);
                navigate('/whatsapplog');
            },2000);
  
          }
          catch(error){
            console.error("Error Updating Data",error);
            setErrorStatus(true);
            setErrormessage("Sorry, couldn't Update Data")
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
        
          }
          finally{
            setCirleLoading(false);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        }
      });
  };
  

  //Delete Mutation
  const handleDeleteWhatsappData = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Delete your details?",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);
          try{
            const response = await request( BASEURL, DeleteWhatsAppLog, {
              id: id,
            });
            setSuccessStatus(true);
            setSucessTitle("Task Progress Deleted Successfully");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/whatsapplog")
            },3000);
            
          }
          catch(error){
            console.error("Error Deleting Data",error);
            setErrorStatus(true);
            setErrormessage("Sorry, couldn't Delete Data")
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
          }
          finally{
            setCirleLoading(false);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };




  const handleCallDataChange = (event, selectEvent) => {
    let callState = { ...callData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "userType":
          {
            if (event.value === "customer") {
              request(BASEURL, allCustomer, {
                organization: "customer",
              })
                .then((res) => {
                  setuserData(res.allCustomer);
                })
                .catch(() => {
                  callState["nameStatus"] = "unchecked";
                  callState["name"] = "";
                });
            } else if (event.value === "lead and prospect") {
              request(BASEURL, allprospect, {
                organization: "lead and prospect",
              }).then((res) => {
                setuserData(res.allLeadprospect);
              });
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              callState["userTypeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
              callState["nameStatus"] = "unchecked";
              callState["name"] = "";
            
              callState["roleStatus"] = "unchecked";
              callState["organizationName"] = "";
              callState["organizationNameStatus"] = "unchecked";
              callState["contactNumber"] = "";
              callState["contactNumberStatus"] = "unchecked";
              setData({
                contactNumber: "",
                role: "",
              });
              
              
            } else {
              callState["userTypeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
              callState["nameStatus"] = "unchecked";
              callState["name"] = "";

              callState["roleStatus"] = "unchecked";
              callState["organizationName"] = "";
              callState["organizationNameStatus"] = "unchecked";
              callState["contactNumber"] = "";
              callState["contactNumberStatus"] = "unchecked";
            }
          }
          break;

        case "name":
          {
            if (event?.label !== undefined) {
              request(BASEURL, getContactdetails, { id: event.value })
                .then((res) => {

                  setData(res?.getContactdetail);
                })
                .catch((error) => {});
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label)) {
              callState["nameStatus"] = "success";
              callState["roleStatus"] = "success";
              callState["contactNumberStatus"] = "success";
              // callState["role"]= Role
            } else {
              setcallData({
                ...callData,
                nameStatus: selectEvent.value === "" ? "unchecked" : "error",
              });
            }
          }
          break;
        case "preparedBy":
          {
            const lengthRegex = new RegExp("^[\\s\\S]*$");
            if (lengthRegex.test(event?.label) === true) {
              callState["preparedByStatus"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              callState["preparedByStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "callType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              callState["callTypeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              callState["callTypeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "organizationName": {
          if (event?.label !== undefined) {
            request(BASEURL, getOrganisationname, {
              organisationname: event.label,
            }).then((res) => {
              setuserName(res.getOrganisationname);
            });
          }
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.value) === true) {
            callState["organizationNameStatus"] = "success";
          }
        }
        case "taskTitle": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            callState[selectEvent.name + "Status"] = "success";
          } else {
            callState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          
          if (event?.value) {
            setTaskId(event.value);
          }
          break;
        }
      }

      callState[selectEvent.name] = event;
    }
    setcallData(callState);
  };

  const handleCallChange = (event) => {

    let prevState = { ...callfieldData };

    if (event?.target === undefined) {

      if (event) {
        prevState["callTypeStatus"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        prevState["callTypeStatus"] =
          event?.label === "" ? "unchecked" : "error";
      }

      prevState["callType"] = event;
      setcallfieldData(prevState);
      return;
    }

    switch (event.target.name) {
      case "startDate":
        // prevState[event.target.name] = event.target.value;
        prevState[event.target.name + "Status"] = "success";
        break;

      case "startTime":
        prevState[event.target.name + "Status"] = event.target.value
          ? "success"
          : "error";
        break;

      case "startTime": {
        if (event?.target.value) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] = "error";
        }
        break;
      }
      case "endTime":
        prevState[event.target.name + "Status"] = event.target.value
          ? "success"
          : "error";
        break;

      case "endTime": {
        if (event?.target.value) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] = "error";
        }
        break;
      }
      case "duration": {
        const alphaNLenghthRegex = new RegExp("^.{2,50}$");
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }

      case "description": {
        const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,500}$");
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
    }

    prevState[event.target.name] = event.target.value;

    setcallfieldData(prevState);
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Whatsapp Log details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                       variant="gradient"
                       color="dark"
                       onClick={handleDeleteWhatsappData}
                       startIcon={<DeleteIcon />}
                     >
                       Delete
                     </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit WhatsApp Log
                    </MaterialTypography>
                  </Stack>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add WhatsApp Log
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                    <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                    <MaterialTypography
                                    sx={{color:'#460058',fontFamily:'Aptos'}}
                                      component="label"
                                      variant="body2"
                                      fontWeight="700"
                                    >
                                      Category / Prospect Information
                                    </MaterialTypography>
                                  </Stack>
            <Grid2 container spacing={2}>
              
                          <Grid2 size={{ xs: 12, sm: 3 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                              <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                              >
                                User Type <span style={{ color: "red" }}>*</span>
                              </MaterialTypography>
                            </MaterialBox>
                            <MaterialSelect
                              name="userType"
                              value={callData.userType}
                              customStyles={{ optionPadding: 20 }}
                              onChange={handleCallDataChange}
                              options={useroptions?.map((item) => {
                                return {
                                  value: item?.value,
                                  label: item?.label,
                                };
                              })}
                              error={callData.userTypeStatus === "error" ? true : false}
                              success={callData.userTypeStatus === "success" ? true : false}
                              isDisabled={togglePage?.view === true ? true : false}
                            />
                          </Grid2>
                          <Grid2 size={{ xs: 5, sm: 3 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                              <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                              >
                                Organization Name<span style={{ color: "red" }}>*</span>
                              </MaterialTypography>
                            </MaterialBox>
                            {isOtherUserType ? (
                              <>
                              <MaterialInput
                                name="organizationName"
                                placeholder=" Organization Name..."
                                value={callfieldData.organizationName}
                                onChange={handleCallChange}
                                error={callfieldData.organizationNameStatus === "error"}
                                success={callfieldData.organizationNameStatus === "success"}
                                disabled={togglePage?.view === true ? true : false}
                              />
                              {callfieldData.organizationNameStatus === "error" &&
                                                      callfieldData.organizationNameErrorMessage && (
                                                        <FormControl error>
                                                          <FormHelperText>
                                                            {callfieldData.organizationNameErrorMessage}
                                                          </FormHelperText>
                                                        </FormControl>
                                                      )}
                                                  </>
                            ) : (
                              <MaterialSelect
                                name="organizationName"
                                customStyles={{ optionPadding: 20 }}
                                onChange={handleCallDataChange}
                                value={callData.organizationName}
                                options={userData?.map((item) => {
                                  return {
                                    value: item?.id,
                                    label: item?.legalName || item?.companyName,
                                  };
                                })}
                                error={
                                  callData.organizationNameStatus === "error" ? true : false
                                }
                                success={
                                  callData.organizationNameStatus === "success"
                                    ? true
                                    : false
                                }
                                isDisabled={togglePage?.view === true ? true : false}
                              />
                            )}
                          </Grid2>
                          {/* <Grid2 size={{ xs: 12, sm: 3 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                              <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                              >
                                Name
                              </MaterialTypography>
                            </MaterialBox>
                            {isOtherUserType ? (
                              <>
                              <MaterialInput
                                name="name"
                                placeholder=" Name..."
                                value={callfieldData.name}
                                customStyles={{ optionPadding: 20 }}
                                onChange={handleCallChange}
                                error={callfieldData.nameStatus === "error"}
                                success={callfieldData.nameStatus === "success"}
                                disabled={togglePage?.view === true ? true : false}
                              />
                               {callfieldData.nameStatus === "error" &&
                                callfieldData.nameErrorMessage && (
                                                        <FormControl error>
                                                          <FormHelperText>
                                                            {callfieldData.nameErrorMessage}
                                                          </FormHelperText>
                                                        </FormControl>
                                                      )}
                                                      </>
                            ) : (
                              <MaterialSelect
                                name="name"
                                value={callData.name}
                                customStyles={{ optionPadding: 20 }}
                                onChange={handleCallDataChange}
                                options={userName?.map((item) => {
                                  return {
                                    value: item?.id,
                                    label: item?.firstName,
                                  };
                                })}
                                error={callData.nameStatus === "error" ? true : false}
                                success={callData.nameStatus === "success" ? true : false}
                                isDisabled={togglePage?.view === true ? true : false}
                              />
                            )}
                          </Grid2>
            
                          <Grid2 size={{ xs: 5, sm: 3 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                              <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                              >
                                Phone Number <span style={{ color: "red" }}>*</span>
                              </MaterialTypography>
                            </MaterialBox>
                          
                              <MaterialInput
                                name="contactNumber"
                                placeholder="Contact..."
                                value={Data.contactNumber}
                                customStyles={{ optionPadding: 20 }}
                                onChange={handleCallDataChange}
                                error={
                                  callData.contactNumberStatus === "error" ? true : false
                                }
                                success={
                                  callData.contactNumberStatus === "success" ? true : false
                                }
                                disabled={true}
                                isDisabled={togglePage?.view === true ? true : false}
                              />
                            
                          </Grid2> */}
                          <Grid2 size={{ xs: 12, sm: 3 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                              <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                              >
                                Associated By <span style={{ color: "red" }}>*</span>
                              </MaterialTypography>
                            </MaterialBox>
                            <MaterialSelect
                              name="preparedBy"
                              customStyles={{ optionPadding: 20 }}
                              value={callData.preparedBy}
                              onChange={handleCallDataChange}
                              options={dropOption?.map((item) => {
                                return {
                                  value: item?.id,
                                  label: item?.username,
                                };
                              })}
                              error={callData.preparedByStatus === "error" ? true : false}
                              success={
                                callData.preparedByStatus === "success" ? true : false
                              }
                              isDisabled={togglePage?.view === true ? true : false}
                            />
                          </Grid2>
                          <Grid2 size={{ xs: 12, sm: 3 }}>
                             <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              >
                              Task Title
                              </MaterialTypography>
                              <MaterialSelect 
                              name="taskTitle"
                              options={titleOptions}
                              value={callData.taskTitle}
                              onChange={handleCallDataChange}
                              isDisabled={togglePage?.view === true ? true : false}
                              success={callData.taskTitleStatus === "success"}
                              error={callData.taskTitleStatus === "error"}
                              />
                          </Grid2>
            </Grid2>
            <Divider />
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                  <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                  <MaterialTypography
                                  sx={{color:'#460058',fontFamily:'Aptos'}}
                                    component="label"
                                    variant="body2"
                                    fontWeight="700"
                                  >
                                    Whatsapp Information
                                  </MaterialTypography>
                                </Stack>
          
            <Grid2 container spacing={2}>
            
              <Grid2 size={{ xs: 5, sm: 3 }}>
                
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Chat Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startDate"
                  type="date"
                  placeholder="eg.01-01-2024"
                  value={callfieldData.startDate}
                  onChange={handleCallChange}
                  error={
                    callfieldData.startDateStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.startDateStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Chat Start Time <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startTime"
                  type="time"
                  placeholder="eg. 10:30"
                  value={callfieldData.startTime}
                  onChange={handleCallChange}
                  error={
                    callfieldData.startTimeStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.startTimeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Chat End Time <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="endTime"
                  type="time"
                  placeholder="eg. 10:30"
                  value={callfieldData.endTime}
                  onChange={handleCallChange}
                  error={
                    callfieldData.endTimeStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.endTimeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Chat Duration<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="duration"
                  placeholder="eg. 2Hours 20Mins "
                  value={callfieldData.duration}
                  onChange={handleCallChange}
                  error={
                    callfieldData.durationStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.durationStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {callfieldData.durationStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Call Duration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Outcome <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="callType"
                  value={callfieldData.callType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleCallChange}
                  options={calltype?.map((item) => {
                    return {
                      value: item?.value,
                      label: item?.label,
                    };
                  })}
                  error={
                    callfieldData.callTypeStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.callTypeStatus === "success" ? true : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Follow Up Actions
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  placeholder="Write description..."
                  multiline
                  rows={3}
                  value={callfieldData.description}
                  onChange={handleCallChange}
                  error={
                    callfieldData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.descriptionStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {callfieldData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description Should be maximum 50 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
            </Grid2>
          
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton variant="gradient" color="dark">
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleEditWhatsappLogData}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleAddWhatsappLogData}
                  >
                    Submit
                  </MaterialButton>
                  {/* <MaterialButton sx={{ m: 2 }} variant="gradient" color="dark">
                    Send Follow-Up Reminder
                  </MaterialButton> */}
                </>
              ) : null}
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AddWhatsappLog;
